import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDZtlLwtnZlaBrCnpZlKqaRigUJ2hJlb5g",
  authDomain: "mivia-manager.firebaseapp.com",
  databaseURL: "https://mivia-manager-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "mivia-manager",
  storageBucket: "gs://mivia-manager-firebasestorage.app",
  messagingSenderId: "YOUR_SENDER_ID",
  appId: "AIzaSyDZtlLwtnZlaBrCnpZlKqaRigUJ2hJlb5g",
};

const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);
export const auth = getAuth(app);
export const db = getFirestore(app);

let _secondaryApp = null;
export function getSecondaryAuth() {
  if (!_secondaryApp) {
    _secondaryApp = initializeApp(firebaseConfig, "Secondary");
  }
  return getAuth(_secondaryApp);
}
